import { render, staticRenderFns } from "./Stream.vue?vue&type=template&id=2c91fbb4&style=position%3Arelative%3B%20min-width%3A%201000px"
import script from "./Stream.vue?vue&type=script&lang=js"
export * from "./Stream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c91fbb4')) {
      api.createRecord('2c91fbb4', component.options)
    } else {
      api.reload('2c91fbb4', component.options)
    }
    module.hot.accept("./Stream.vue?vue&type=template&id=2c91fbb4&style=position%3Arelative%3B%20min-width%3A%201000px", function () {
      api.rerender('2c91fbb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoCall/Stream.vue"
export default component.exports